import { render, staticRenderFns } from "./CreateBooking.vue?vue&type=template&id=5c436856&lang=html&"
import script from "./CreateBooking.vue?vue&type=script&lang=js&"
export * from "./CreateBooking.vue?vue&type=script&lang=js&"
import style0 from "./CreateBooking.vue?vue&type=style&index=0&id=5c436856&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports